import { TFaqCategoryPayload } from 'shared/types/faq.types';

export const DEFAULT_CATEGORY_NAME = 'Общее';
export const DEFAULT_CATEGORY_VALUE = 'null';
export const DEFAULT_CATEGORY_ICON = 'icon-Fatfill';

export const DEFAILT_CATEGORY: TFaqCategoryPayload = {
  icon: DEFAULT_CATEGORY_ICON,
  id: DEFAULT_CATEGORY_VALUE,
  name: DEFAULT_CATEGORY_NAME,
};
